/**
 * Galerie produit : filet de securite sur l'attribut [in-viewport].
 *
 * Horizon n'autorise le defilement d'un carrousel qu'une fois l'attribut
 * [in-viewport] pose sur <slideshow-component>. Tant qu'il manque, la
 * feuille du theme impose :
 *
 *   slideshow-component:not([in-viewport]) slideshow-slides {
 *     overflow: hidden;
 *   }
 *
 * L'attribut est pose par un IntersectionObserver (voir slideshow.js).
 * C'est une optimisation voulue par Shopify : elle limite le nombre de
 * couches de composition, un trop grand nombre faisant planter Safari
 * iOS. On ne la retire donc pas.
 *
 * DEUX MOMENTS OU L'ATTRIBUT MANQUE
 *
 * 1. A l'arrivee sur la fiche produit. En faisant glisser la galerie
 *    AUSSITOT, la deuxieme image n'apparait jamais ; en faisant d'abord
 *    defiler la page, puis en revenant a la galerie, tout fonctionne.
 *    Signature d'un attribut qui arrive trop tard : le defilement de la
 *    page force le calcul d'intersection et debloque la galerie.
 *
 * 2. Apres un CHANGEMENT DE VARIANTE. Le theme re-rend la galerie, et
 *    slideshow.js retire lui-meme l'attribut a la deconnexion :
 *
 *      unobserve(slideshow) {
 *        this.#observer?.unobserve(slideshow);
 *        slideshow.removeAttribute('in-viewport');   // ligne 76
 *      }
 *
 *    appele depuis disconnectedCallback (ligne 147). Le bug est donc
 *    reamorce a chaque changement de variante, a l'identique.
 *
 * La premiere version de ce script ne couvrait que le cas 1 : elle
 * ecoutait DOMContentLoaded, pageshow, un minuteur unique et
 * shopify:section:load — ce dernier ne se declenchant QUE dans
 * l'editeur de theme, jamais sur la boutique en ligne. Un changement de
 * variante ne reveillait donc rien.
 *
 * Ce script ne remplace pas l'observateur : il pose l'attribut sur les
 * carrousels DEJA visibles, avec la meme marge de 100 px que
 * l'observateur du theme. Un carrousel hors ecran n'est jamais touche,
 * la protection iOS reste donc entiere. Si l'observateur fonctionne
 * normalement, le script ne fait que confirmer ce qu'il aurait fait.
 */
(function () {
  /* Meme marge que l'observateur du theme (rootMargin: '100px'). */
  var MARGE = 100;

  /**
   * Un carrousel est-il assez proche de l'ecran pour que l'observateur
   * du theme lui aurait, de toute facon, pose l'attribut ?
   */
  function estAPortee(carrousel) {
    var hauteur = window.innerHeight || document.documentElement.clientHeight;
    var r = carrousel.getBoundingClientRect();

    /* Element sans dimension : pas encore mis en page, on laisse
       l'observateur s'en charger. */
    if (!r.width && !r.height) return false;

    return r.bottom > -MARGE && r.top < hauteur + MARGE;
  }

  function activerCeQuiEstVisible() {
    Array.prototype.forEach.call(
      document.querySelectorAll('slideshow-component:not([in-viewport])'),
      function (carrousel) {
        if (estAPortee(carrousel)) carrousel.setAttribute('in-viewport', '');
      }
    );
  }

  /* Les mutations arrivent en rafale pendant un re-rendu : on regroupe.
     Deux passes, car le re-rendu de variante passe par une transition de
     vue — le rendu est suspendu le temps de l'animation, et les
     dimensions ne sont fiables qu'apres. */
  var enAttente = false;

  function planifier() {
    if (enAttente) return;
    enAttente = true;

    setTimeout(function () {
      enAttente = false;
      activerCeQuiEstVisible();
    }, 0);

    setTimeout(activerCeQuiEstVisible, 400);
  }

  function contientUnCarrousel(noeud) {
    return (
      noeud.nodeType === 1 &&
      (noeud.tagName === 'SLIDESHOW-COMPONENT' || !!noeud.querySelector('slideshow-component'))
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activerCeQuiEstVisible);
  } else {
    activerCeQuiEstVisible();
  }

  /* Retour arriere depuis le cache de navigation (frequent sur iOS). */
  window.addEventListener('pageshow', activerCeQuiEstVisible);

  /* Editeur de theme uniquement, mais sans frais : on le garde. */
  document.addEventListener('shopify:section:load', activerCeQuiEstVisible);

  /* Le vrai filet : on surveille le DOM plutot que de deviner le nom de
     l'evenement emis par le theme. Deux declencheurs suffisent —
     l'apparition d'un carrousel, et le retrait de l'attribut. */
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.type === 'attributes') {
          planifier();
          return;
        }

        for (var j = 0; j < m.addedNodes.length; j++) {
          if (contientUnCarrousel(m.addedNodes[j])) {
            planifier();
            return;
          }
        }
      }
    }).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['in-viewport'],
    });
  }

  /* Dernier recours, au contact. Si le doigt se pose sur une galerie a
     laquelle il manque encore l'attribut, on le pose avant que le geste
     ne soit interprete. Ne sert que si tout ce qui precede a echoue. */
  document.addEventListener(
    'pointerdown',
    function (evenement) {
      var cible = evenement.target;
      if (!cible || !cible.closest) return;

      var carrousel = cible.closest('slideshow-component:not([in-viewport])');
      if (carrousel && estAPortee(carrousel)) carrousel.setAttribute('in-viewport', '');
    },
    { capture: true, passive: true }
  );

  /* Une passe apres la mise en page initiale : sur une fiche produit, la
     galerie peut n'obtenir ses dimensions qu'apres le chargement des
     images. */
  setTimeout(activerCeQuiEstVisible, 600);
})();
